(() => {
  const name = 'carisma-trust-rail';
  if (customElements.get(name)) return;
  class TrustRail extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal:this.abort.signal });
      this.track = this.querySelector('[data-trust-track]');
      this.group = this.querySelector('[data-trust-group]');
      this.pause = this.querySelector('[data-trust-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.auto !== 'true' || this.motion.matches || this.dataset.editor === 'true';
      this.visible = true; this.touching = false; this.keyboardFocus = false;
      const update = () => { this.pause.textContent = this.paused ? 'Resume' : 'Pause'; };
      this.refresh = () => {
        this.track.querySelectorAll('[data-trust-clone]').forEach(x=>x.remove());
        const previousWidth=this.width;
        const previousPosition=this.autoPosition??this.track.scrollLeft;
        this.width = this.group.getBoundingClientRect().width;
        const continuous = !!this.closest('.vita-rail') && this.width > 0;
        this.overflowing = continuous || this.width > this.track.clientWidth + 1;
        if(this.overflowing) {
          const copies = Math.max(1, Math.ceil(this.track.clientWidth / this.width) + 1);
          for (let copy = 0; copy < copies; copy++) {
          const clone = this.group.cloneNode(true); clone.removeAttribute('data-trust-group'); clone.dataset.trustClone = ''; clone.setAttribute('aria-hidden','true');
          clone.querySelectorAll('[id]').forEach(element=>element.removeAttribute('id'));
          clone.querySelectorAll('a,button,[tabindex]').forEach(element=>element.tabIndex=-1); this.track.append(clone);
          }
        }
        this.autoPosition=this.width>0?((previousWidth?previousPosition/previousWidth*this.width:previousPosition)%this.width+this.width)%this.width:0;
        this.track.scrollLeft=this.autoPosition;
        const showArrows = this.dataset.showArrows !== 'false';
        const showPause = this.dataset.showPause !== 'false' && this.dataset.auto === 'true';
        this.querySelector('[data-trust-controls]').hidden = !this.overflowing || (!showArrows && !showPause);
        this.querySelector('[data-trust-prev]').hidden = !showArrows;
        this.querySelector('[data-trust-next]').hidden = !showArrows;
        this.pause.hidden = !showPause;
      };
      on(this.pause,'click',()=>{this.paused=!this.paused;update();});
      const step = direction => { this.paused=true;update();this.track.scrollBy({left:direction*this.track.clientWidth*.7,behavior:this.motion.matches?'auto':'smooth'}); };
      on(this.querySelector('[data-trust-prev]'),'click',()=>step(-1));
      on(this.querySelector('[data-trust-next]'),'click',()=>step(1));
      on(this,'focusin',e=>{this.keyboardFocus=e.target.matches(':focus-visible');});
      on(this,'focusout',()=>{this.keyboardFocus=false;});
      on(this.track,'dragstart',e=>e.preventDefault());
      on(this.track,'click',e=>{if(Date.now()<(this.suppressUntil||0)){e.preventDefault();e.stopPropagation();}}, {capture:true});
      on(this.track,'pointerdown',e=>{
        this.touching=true;this.keyboardFocus=false;
        if(e.pointerType==='mouse'&&e.button===0)this.drag={id:e.pointerId,x:e.clientX,left:this.track.scrollLeft,moved:false};
      });
      on(window,'pointermove',e=>{
        if(!this.drag||this.drag.id!==e.pointerId)return;
        const dx=e.clientX-this.drag.x;
        if(Math.abs(dx)>5){this.drag.moved=true;this.track.classList.add('is-dragging');this.track.setPointerCapture(e.pointerId);}
        if(this.drag.moved){e.preventDefault();this.track.scrollLeft=this.drag.left-dx;}
      });
      const end=()=>{this.touching=false;if(!this.drag)return;const drag=this.drag;this.drag=null;if(drag.moved)this.suppressUntil=Date.now()+350;if(this.track.hasPointerCapture(drag.id))this.track.releasePointerCapture(drag.id);this.track.classList.remove('is-dragging');};
      on(window,'pointerup',end);on(window,'pointercancel',end);on(this.track,'lostpointercapture',end);
      on(this.motion,'change',()=>{if(this.motion.matches){this.paused=true;update();}});
      this.resize=new ResizeObserver(this.refresh);this.resize.observe(this.track);this.resize.observe(this.group);
      this.view=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;});this.view.observe(this);
      update();this.refresh();this.last=0;
      const tick=time=>{
        const elapsed=this.last?Math.min(time-this.last,50):0;this.last=time;
        if(this.width>0&&this.overflowing&&!this.paused&&this.visible&&!document.hidden&&!this.keyboardFocus&&!this.touching&&!this.drag){
          const delta=(Number(this.dataset.speed)||20)*elapsed/1000*(this.dataset.direction==='right'?-1:1);
          let next=(this.autoPosition ?? this.track.scrollLeft)+delta;
          next=((next%this.width)+this.width)%this.width;
          this.autoPosition=next;this.track.scrollLeft=next;
        } else { this.autoPosition=null; }
        this.frame=requestAnimationFrame(tick);
      };this.frame=requestAnimationFrame(tick);
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.view?.disconnect();cancelAnimationFrame(this.frame);this.drag=null;this.track?.classList.remove('is-dragging');}
  }
  customElements.define(name,TrustRail);
})();
